/* Panier coulissant de la fiche NovaWifi, branché sur Horizon pour tout le store :
   s'ouvre après chaque ajout au panier (fiche, ajout rapide, barre collante) et au clic sur l'icône panier. */
(() => {
  const panier = document.getElementById('lvPanier');
  if (!panier || !window.fetch || panier.dataset.pret) return;
  panier.dataset.pret = '1';

  const lignes = panier.querySelector('.nvwp__lignes');
  const vide = panier.querySelector('.nvwp__vide');
  const pied = panier.querySelector('.nvwp__pied');
  const somme = panier.querySelector('.nvwp__somme');
  const t = panier.dataset;
  const langue = t.lang === 'fr' ? 'fr-FR' : t.lang === 'de' ? 'de-AT' : 'sv-SE';
  let occupe = false;
  let version = 0;
  const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const ech = (x) => String(x == null ? '' : x)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  const fmt = (cents, devise) => {
    const d = cents % 100 ? 2 : 0;
    try {
      return new Intl.NumberFormat(langue, { style: 'currency', currency: devise, minimumFractionDigits: d, maximumFractionDigits: d }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(d) + ' ' + devise;
    }
  };

  const figer = (actif) => {
    document.documentElement.style.overflow = actif ? 'hidden' : '';
  };

  const ouvrir = () => {
    panier.classList.add('est-ouvert');
    panier.setAttribute('aria-hidden', 'false');
    figer(true);
    const f = panier.querySelector('.nvwp__fermer');
    if (f) f.focus({ preventScroll: true });
  };

  const fermer = () => {
    panier.classList.remove('est-ouvert');
    panier.setAttribute('aria-hidden', 'true');
    figer(false);
    panier.querySelectorAll('.est-attente').forEach((b) => b.classList.remove('est-attente'));
  };

  const carte = (article, devise) => {
    const source = article.image ? article.image + (article.image.indexOf('?') > -1 ? '&' : '?') + 'width=150' : '';
    const visuel = source ? '<img class="nvwp__ligne-img" src="' + ech(source) + '" alt="" width="70" height="70">' : '';
    const variante = article.variant_title ? '<span class="nvwp__ligne-var">' + ech(article.variant_title) + '</span>' : '';
    return '<div class="nvwp__ligne" data-cle="' + ech(article.key) + '" data-q="' + article.quantity + '">'
      + '<a href="' + ech(article.url) + '">' + visuel + '</a>'
      + '<div class="nvwp__ligne-info">'
        + '<strong>' + ech(article.product_title) + '</strong>'
        + variante
        + '<div class="nvwp__ligne-bas">'
          + '<span class="nvwp__qte">'
            + '<button type="button" class="nvwp__qte-b" data-act="moins" aria-label="' + ech(t.tMoins) + '">&minus;</button>'
            + '<span class="nvwp__qte-n">' + article.quantity + '</span>'
            + '<button type="button" class="nvwp__qte-b" data-act="plus" aria-label="' + ech(t.tPlus) + '">+</button>'
          + '</span>'
          + '<strong>' + fmt(article.final_line_price, devise) + '</strong>'
        + '</div>'
      + '</div>'
      + '<button type="button" class="nvwp__retirer" data-act="vider" aria-label="' + ech(t.tRetirer) + '">&times;</button>'
    + '</div>';
  };

  // Met à jour la pastille du panier d'Horizon dans l'en-tête
  const pastille = (n) => {
    document.querySelectorAll('cart-icon').forEach((icone) => {
      try { if (typeof icone.renderCartBubble === 'function') icone.renderCartBubble(n, false); } catch (e) {}
    });
  };

  const peindre = (p) => {
    const rempli = p.items && p.items.length > 0;
    vide.style.display = rempli ? 'none' : 'block';
    pied.style.display = rempli ? 'block' : 'none';
    lignes.innerHTML = (p.items || []).map((a) => carte(a, p.currency)).join('');
    if (somme) somme.textContent = fmt(p.items_subtotal_price || 0, p.currency || 'SEK');
    pastille(p.item_count || 0);
  };

  // Les réponses arrivées dans le désordre ne repeignent pas par-dessus une plus récente
  const relire = () => {
    const v = ++version;
    return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => r.json())
      .then((p) => { if (v === version) peindre(p); return p; });
  };

  const majQte = (cle, q, ligne) => {
    if (occupe) return;
    occupe = true;
    if (ligne) ligne.classList.add('est-occupe');
    fetch(racine + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cle, quantity: q })
    })
      .then((r) => r.json())
      .then((p) => {
        occupe = false;
        if (p && p.items) { version++; peindre(p); } else return relire();
      })
      .catch(() => { occupe = false; relire(); });
  };

  lignes.addEventListener('click', (e) => {
    const bouton = e.target.closest('[data-act]');
    if (!bouton) return;
    const ligne = bouton.closest('.nvwp__ligne');
    if (!ligne) return;
    const q = Number(ligne.dataset.q);
    const act = bouton.dataset.act;
    majQte(ligne.dataset.cle, act === 'plus' ? q + 1 : act === 'moins' ? q - 1 : 0, ligne);
  });

  panier.addEventListener('click', (e) => {
    if (e.target.closest('.nvwp__voile, .nvwp__fermer, .nvwp__continuer')) fermer();
    const commander = e.target.closest('.nvwp__commander');
    if (commander) commander.classList.add('est-attente');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panier.classList.contains('est-ouvert')) fermer();
  });

  const surPagePanier = () => /\/cart\/?$/.test(location.pathname);

  // Ajout au panier par le thème (fiche produit, ajout rapide, barre collante)
  // Le volet s'ouvre tout de suite en mode « chargement », puis se remplit quand l'ajout est confirmé.
  const charge = (actif) => panier.classList.toggle('est-charge', actif);
  // Ajout refusé par Shopify (stock, quantité max…) : Horizon résout la promesse avec detail.didError
  const echec = (r) => Boolean(r && r.detail && r.detail.didError);
  document.addEventListener('shopify:cart:lines-update', (e) => {
    if (!e || e.action !== 'add' || surPagePanier()) return;
    const suite = e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve({});
    charge(true);
    // Ajout depuis une fenêtre modale (ajout rapide) : ouvrir quand elle se ferme, sinon le volet resterait dessous
    const modale = e.target && e.target.closest ? e.target.closest('dialog[open]') : null;
    let annule = false;
    if (modale) {
      let fait = false;
      const go = () => { if (!fait && !annule) { fait = true; ouvrir(); } };
      modale.addEventListener('close', go, { once: true });
      suite.then((r) => { if (!echec(r)) setTimeout(() => { if (!modale.open) go(); }, 400); }, () => {});
    } else {
      ouvrir();
    }
    const garde = setTimeout(() => { charge(false); relire(); }, 12000);
    // En cas d'échec, on referme le volet : le message d'erreur d'Horizon reste lisible sous le bouton
    suite
      .then((r) => { if (echec(r)) { annule = true; fermer(); } return relire(); })
      .catch(() => { annule = true; fermer(); return relire(); })
      .then(() => { clearTimeout(garde); charge(false); }, () => { clearTimeout(garde); charge(false); });
  });
  document.addEventListener('shopify:cart:error', () => {
    if (panier.classList.contains('est-ouvert')) fermer();
  });

  // Clic sur l'icône panier de l'en-tête : notre volet à la place de celui d'Horizon
  window.addEventListener('click', (e) => {
    const declencheur = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], a.action__cart');
    if (!declencheur || surPagePanier() || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    relire();
    ouvrir();
  }, true);

  // Retour arrière depuis le checkout (page restaurée du cache)
  window.addEventListener('pageshow', (e) => { if (e.persisted) { fermer(); relire(); } });

  relire();
})();
